/** Guardas de ruta: sesión obligatoria y permiso por módulo. La defensa real es el servidor. */
import { PERMISO_ETIQUETA, type Nivel, type Permiso } from '@mg/shared';
import { Navigate, Outlet, useLocation } from 'react-router';
import { Vacio } from '@/componentes/estados.tsx';
import { Cargando } from '@/componentes/estados.tsx';
import { useAuth } from '@/lib/auth.tsx';
import { ShieldOff } from 'lucide-react';

export function RutaPrivada() {
  const { usuario, cargando } = useAuth();
  const location = useLocation();
  if (cargando) return <Cargando className="p-8" />;
  if (!usuario) return <Navigate to="/login" replace state={{ desde: location.pathname }} />;
  return <Outlet />;
}

/**
 * Deja pasar con el permiso (o con CUALQUIERA de los de la lista, en pantallas que reúnen varias funciones, como
 * Reportes). «Sin acceso» nombra el permiso como lo ve la dueña en Configuración, no con su nombre interno
 * (re-auditoría 2026-10-18, ronda 2, hallazgo 6-H11).
 */
export function GuardaPermiso({ permiso, nivel = 'lectura', children }: { permiso: Permiso | readonly Permiso[]; nivel?: Nivel; children: React.ReactNode }) {
  const { puede } = useAuth();
  const lista: readonly Permiso[] = typeof permiso === 'string' ? [permiso] : permiso;
  if (!lista.some((p) => puede(p, nivel))) {
    const nombres = lista.map((p) => `«${PERMISO_ETIQUETA[p] ?? p}»`);
    const falta = nombres.length === 1 ? `el permiso ${nombres[0]}` : `ninguno de estos permisos: ${nombres.join(', ')}`;
    return <Vacio icono={<ShieldOff className="h-6 w-6" />} titulo="Sin acceso" descripcion={`Tu usuario no tiene ${falta}. Si crees que es un error, consulta a la dueña.`} />;
  }
  return <>{children}</>;
}
